<template>
  <div class="welcome">
    <div class="row">
      <div class="col s12 m8 offset-m2 header">
        <br />
        <br />
        <br />
        <center>
          <h1 class>
            Uma nova forma de utilizar
            <b>ambientes de Simulação</b>
          </h1>
          <h5>
            Optweex é uma ferramenta
            <b>gratuita</b>, de fácil utilização e portável, saiba mais fazendo o seu cadastro!
          </h5>
          <div class="row">
            <a href="#" @click="google_login" class="btn btn-large col s8 offset-s2">
              <b>Entrar!</b>
            </a>
          </div>
        </center>
      </div>
    </div>
    <div class="row footer">
      <center>
        <p class="text-grey">
          Optweex é fruto da parceria entre o Instituto Federal de São Paulo - IFSP Campus Itapetininga
          <br />e a Escola de Engenharia de São Carlos - EESC-USP
        </p>
        <br />
      </center>
    </div>
  </div>
</template>
<script>
import firebase from "firebase";
import M from "materialize-css";
export default {
  name: "welcome",
  data() {},
  methods: {
    google_login: function() {
      var provider = new firebase.auth.GoogleAuthProvider();
      firebase.auth().languageCode = "pt";
      firebase
        .auth()
        .signInWithPopup(provider)
        .then(() => {
          location.href= "/home";
        })
        .catch(function(error) {
          M.toast({ html: error, classes: "rounded red" });
          // var errorCode = error.code;
          // var errorMessage = error.message;
          // var email = error.email;
          // var credential = error.credential;
        });
    },
    isUserEqual: function(googleUser, firebaseUser) {
      if (firebaseUser) {
        var providerData = firebaseUser.providerData;
        for (var i = 0; i < providerData.length; i++) {
          if (
            providerData[i].providerId ===
              firebase.auth.GoogleAuthProvider.PROVIDER_ID &&
            providerData[i].uid === googleUser.getBasicProfile().getId()
          ) {
            // We don't need to reauth the Firebase connection.
            return true;
          }
        }
      }
      return false;
    }
  },
  mounted(){
    this.isUserEqual();
  }
};
</script> 